/* -------------------------------------------------------------------------- */
/*                                   PROFILE                                  */

/* -------------------------------------------------------------------------- */

import {Button, Card, Col, Row} from "antd";
import React from "react";
import {DetailProfileWidget} from "@/pages/admin/member/[id]/AdminEditMember";
import FilePreview from "@/components/file-preview/file-preview";
import {maritalEnum} from "@/lib/helper/enumType";
import {formatDate} from "@/lib/helper/date";

export default function ProfileTab({
                                       student,
                                       setModalDocuments,
                                       setModalIdentify,
                                       setModalLocation,
                                       setModalMobile,
                                       updateProfileDoc
                                   }) {

    return (
        <div className="flex flex-col gap-4">

            <Row gutter={[16, 16]}>

                <Col xs={24} lg={12}>

                    <Card title="اطلاعات هویتی" extra2={<>
                        <Button variant={'link'} type={'link'} onClick={() => setModalIdentify(true)}>ویرایش</Button>
                    </>}>

                        <div className="flex flex-col gap-3">

                            <DetailProfileWidget
                                label={"نام"}
                                value={student?.firstname}
                            />

                            <DetailProfileWidget
                                label={"نام خانوادگی"}
                                value={student?.lastname}
                            />

                            <DetailProfileWidget
                                label={"نام پدر"}
                                value={student?.father}
                            />

                            <DetailProfileWidget
                                label={"تاریخ تولد"}
                                value={
                                    student?.birthdate
                                        ? formatDate(student?.birthdate)
                                        : null
                                }
                            />

                            <DetailProfileWidget
                                label={"وضعیت تاهل"}
                                value={maritalEnum(student?.marital)}
                            />

                            <DetailProfileWidget
                                label={"ملیت"}
                                value={student?.nationality_detail?.fa_name}
                            />

                        </div>

                    </Card>

                </Col>

                <Col xs={24} lg={12}>

                    <Card title="اطلاعات تماس" extra2={<>
                        <Button variant={'link'} type={'link'} onClick={() => setModalMobile(true)}>ویرایش</Button>
                    </>}>

                        <div className="flex flex-col gap-3">

                            <DetailProfileWidget
                                label={'موبایل'}
                                value={student?.mobile}
                            />

                            <DetailProfileWidget
                                label={'موبایل دوم'}
                                value={student?.mobile2}
                            />

                            <DetailProfileWidget
                                label={'تلفن ثابت'}
                                value={student?.phone}
                            />

                            <DetailProfileWidget
                                label={'ایمیل'}
                                value={student?.email}
                            />

                        </div>

                    </Card>

                </Col>

                <Col xs={24}>

                    <Card title="آدرس" extra2={<>
                        <Button variant={'link'} type={'link'} onClick={() => setModalLocation(true)}>ویرایش</Button>
                    </>}>

                        <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">

                            <DetailProfileWidget
                                label={'کشور'}
                                value={student?.country_detail?.fa_name}
                            />

                            <DetailProfileWidget
                                label={'استان'}
                                value={student?.province_detail?.fa_name}
                            />

                            <DetailProfileWidget
                                label={'شهر'}
                                value={student?.city_detail?.localname}
                            />

                            <DetailProfileWidget
                                label={'کدپستی'}
                                value={student?.zipcode}
                            />

                            <DetailProfileWidget
                                label={'آدرس'}
                                value={student?.address}
                            />

                        </div>

                    </Card>

                </Col>

                <Col xs={24}>

                    <Card title="مدارک" extra2={<>
                        <Button variant={'link'} type={'link'} onClick={() => setModalDocuments(true)}>ویرایش</Button>
                    </>}>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">

                            <Card size="small">

                                <div className="flex flex-col gap-2">

                                    <span>
                                        کارت شناسایی
                                    </span>

                                    <FilePreview fileUrl={student?.file1}/>

                                </div>

                            </Card>

                            <Card size="small">

                                <div className="flex flex-col gap-2">

                                    <span>
                                        کارت ملی
                                    </span>

                                    <FilePreview fileUrl={student?.file2}/>

                                </div>

                            </Card>

                            <Card size="small">

                                <div className="flex flex-col gap-2">

                                    <span>
                                        مدرک تحصیلی
                                    </span>

                                    <FilePreview fileUrl={student?.file3}/>

                                </div>

                            </Card>

                        </div>

                    </Card>

                </Col>

            </Row>

        </div>
    );
}
